import * as stylex from "@stylexjs/stylex";
import Link from "next/link";
import * as M from "../../materials";
import { O, pipe, R } from "../../prelude";
import { findArticleAliasRelaxed, foldRAliasArticle_ } from "../../routes";
const colorStyle = (highlightColor)=>({
        backgroundColor: highlightColor,
        color: M.utils.getContrastText(highlightColor, {
            dark: M.palette.text.black,
            light: M.palette.text.white
        })
    });
const colorOnDarkStyle = (highlightColor)=>({
        backgroundColor: highlightColor,
        color: M.utils.getContrastText(highlightColor, {
            dark: M.unescoDarkBlue,
            light: M.palette.text.white
        })
    });
/**
 * This component's exact name is used in ScrollySection to automatically
 * pass in props. Make sure that if you change the name, you also change
 * the name there.
 *
 * (It would be nice to rely on Highlight.name for this comparison, but
 * unfortunately, this does not work in production).
 */ export const Highlight = ({ children, color, onDark })=>{
    return color ? <mark className="xt0psk2 x1cum3z5 xo5v014 x1t6r6ck" style={onDark ? colorOnDarkStyle(color) : colorStyle(color)}>
      {children}
    </mark> : <span>{children}</span>;
};
export const HighlightByIndex = ({ children, index: idx })=>{
    // If no index is given or the index is "-1", return a mid grey
    const color = idx == null || +idx === -1 ? M.grayscalePalette[4] : M.fromIndexDiscrete(M.colorRanges.discrete, +idx);
    return <Highlight color={color}>{children}</Highlight>;
};
export const HighlightByPalette = ({ children, palette: paletteO, index: idx })=>{
    const palette = pipe(O.fromNullable(paletteO), O.chain((id)=>R.lookup(`q${id}Palette`, M)), O.getOrElse(()=>M.grayscalePalette));
    const color = M.fromIndexDiscrete(palette, idx == null ? 0 : +idx);
    return <Highlight color={color}>{children}</Highlight>;
};
export const HighlightByTheme = ({ children, theme })=>{
    return pipe(findArticleAliasRelaxed(theme), O.fold(()=><span>{children}</span>, (alias)=>{
        const color = foldRAliasArticle_({
            access: ()=>M.q01Palette[2],
            equity: ()=>M.q04Palette[7],
            learning: ()=>M.q06Palette[6],
            trajectories: ()=>M.q06Palette[6],
            quality: ()=>M.q08Palette[6],
            finance: ()=>M.q09Palette[7],
            "finance-aid": ()=>M.q09Palette[7]
        })(alias);
        return <Link href={`/articles/${alias}`} className="x1pd3egz">
            <Highlight color={color} onDark>
              {children}
            </Highlight>
          </Link>;
    }));
};
